import * as Api from '../../../api/Api';
import { useState } from 'react';
import PermissionsGate from '../../../api/PermissionsGate';
import { SCOPES } from '../../../config/permissions-map';
import { Unauthorized } from '../../Global/unauthorized';
import TransposedTableFromServer from "../../../Components/Table/TransposedTableFromServer";
import { useGetToken } from '../../../Hooks/CustomHooks';
import { PageTitle } from '../../../../_metronic/layout/core';
import { registerLocale } from 'react-datepicker';
import es from "date-fns/locale/es";
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import * as Utilities from '../../../Components/Utils/Utils';
import DatePickerYear from 'react-datepicker';

export default function AfluenciaDiariaPeatonal({ title }) {
    // let formatLocale = { day: '2-digit', month: '2-digit', year: 'numeric' };
    // const [date, setDate] = useState(moment().subtract(2, 'year').toDate());
    // let dateFormated = moment(date).toDate().toLocaleString(undefined, formatLocale);


    const [año1, setAño1] = useState(new Date());
    let dateFormated1 = año1.getFullYear();

    const d = new Date();
    const year = d.getFullYear();
    const month = d.getMonth();
    const day = d.getDate();

    const [año2, setAño2] = useState(new Date(Utilities.getAnioComparativo(), month, day));
    let dateFormated2 = año2.getFullYear();

    const dYear = new Date();
    dYear.setFullYear(año1.getFullYear());
    const [dateMes, setDateMes] = useState(new Date(dYear.getFullYear(), dYear.getMonth(), dYear.getDate()));

    let dateFormatedMes = ("0" + (dateMes.getMonth() + 1)).slice(-2);

    const animatedComponents = makeAnimated();
    const [unidadEconomica, setUnidadEconomica] = useState(Utilities.getListUnidadesEconomicas().list[0]);
    const [zona, setZona] = useState('Perimetro');
    const [zoneOptions, setZoneOptions] = useState([
        {
            value: 'Perimetro',
            label: 'Perimetro Ampliado'
        },
        {
            value: 'Oasis',
            label: 'Oasis'
        }
    ])
    const [zoneSelected, setZoneSelected] = useState(zoneOptions[0]);
    let unidadesEconomicasList = Utilities.getListUnidadesEconomicas(true);

    const getOptionValue = idDefault => {
        return unidadesEconomicasList.list.filter(obj => obj.value === idDefault)
    }

    const onChangeGraphType = (inputValue) => {
        //setEnableQuery(true); //Everytime the select changes, it enables the useQuery condition for CharFromServer
        if (inputValue.value != 3) {
            setZona('Perimetro')
            setZoneSelected(zoneOptions[0])
            setZoneOptions(zoneOptions.filter(zone => (zone.value !== 'Oasis')))
        } else {
            setZoneOptions([
                {
                    value: 'Perimetro',
                    label: 'Perimetro'
                },
                {
                    value: 'Oasis',
                    label: 'Oasis'
                }
            ])
        }
        setUnidadEconomica(inputValue);
    }

    const onChangeZone = (value) => {
        setZona(value.value)
        setZoneSelected(value)
    }
    let transposedSettings = {
        type: ["string", "float", "string", "float", "percentage"],
        hightlighted: [true, false, true, false, true],
        rowsClasses: [],
        rowsSpan: [2, null, 2, null, 1],
        firstColumn: [
            dateFormated1,
            "",
            dateFormated2,
            "",
            "Variación"
        ]
    }
    registerLocale("es", es);
    return (
        <>
            <PermissionsGate RenderError={() => <Unauthorized />} scopes={[SCOPES.AFLUENCIA_DIARIA_PEATONAL]} >
                <PageTitle>{title}</PageTitle>

                <div className="card my-5">
                    <div className='card-header border-0 pt-5'>
                        <div className="d-flex flex-wrap flex-stack mb-6">
                            <div className="d-flex flex-wrap my-2">
                                <div className="p-2" style={{ minWidth: "200px" }}>
                                    <div className="fw-bold fs-7 text-gray-600 mb-1">Mall:</div>
                                    <Select
                                        classNamePrefix='filter'
                                        components={animatedComponents}
                                        defaultValue={getOptionValue(unidadesEconomicasList.defaultId)}
                                        isMulti={false}
                                        closeMenuOnSelect={true}
                                        options={unidadesEconomicasList.list}
                                        onChange={(onChangeGraphType)}
                                    />
                                </div>
                                <div className='p-2 afluencia-datepicker'>
                                    <div className="fw-bold fs-7 text-gray-600 mb-1">Mes Cierre:</div>
                                    <DatePickerYear
                                        className="form-control form-control-transparent pe-5"
                                        locale="es"
                                        selected={dateMes}
                                        onChange={(dateX) => dateX && setDateMes(dateX)}
                                        dateFormat="MM/yyyy"
                                        showMonthYearPicker
                                        maxDate={new Date()}
                                    />
                                </div>

                                <div className='p-2'>
                                    <div className="fw-bold fs-7 text-gray-600 mb-1">Año Comparativo:</div>
                                    <DatePickerYear
                                        className="form-control form-control-transparent pe-5"
                                        locale="es"
                                        selected={año2}
                                        onChange={(dateX) => dateX && setAño2(dateX)}
                                        dateFormat="yyyy"
                                        showYearPicker
                                        minDate={Utilities.add_years(new Date(), -6)}
                                        maxDate={new Date()}
                                    />
                                </div>
                            </div>
                            <div className="d-flex flex-wrap my-2">
                                <div className="p-2" style={{ minWidth: "200px" }}>
                                    <div className="fw-bold fs-7 text-gray-600 mb-1">Zona:</div>
                                    <Select
                                        classNamePrefix='filter'
                                        components={animatedComponents}
                                        defaultValue={zoneOptions[0]}
                                        isMulti={false}
                                        closeMenuOnSelect={true}
                                        options={zoneOptions}
                                        onChange={(onChangeZone)}
                                        value={zoneSelected}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="card-body tab-content pt-0">
                        <TransposedTableFromServer
                            idContent={"AfluenciaDiariaPeatonal" + dateFormatedMes + " " + dateFormated1 + " " + dateFormated2 + "1"}
                            header={[{ Header: 'Año', accessor: dateFormated1 + "", headerClassName: 'text-gray-800 mb-1' }]}
                            setAuxData={null}
                            apiService={Api.AfluenciaDiariaPeatonal}
                            args={{ anio1: dateFormated1, anio2: dateFormated2, mes: dateFormatedMes, numero: 1, unidadEconomica: unidadEconomica.value, zona: zona, token: useGetToken() }} // * para filters
                            conditions={true}
                            hideFilter={true}
                            pgSize={15}
                            hidePagination={true}
                            fileNameDownload={"Reporte Afluencia Diaria Peatonal - " + dateFormatedMes + " " + dateFormated1 + " " + dateFormated2 + "1"}
                            transposedSettings={transposedSettings}
                            frecuency={"Diaria"}
                        />
                        <TransposedTableFromServer
                            idContent={"AfluenciaDiariaPeatonal" + dateFormatedMes + " " + dateFormated1 + " " + dateFormated2 + "2"}
                            header={[{ Header: 'Año', accessor: "year2", headerClassName: 'text-gray-800 mb-1' }]}
                            setAuxData={null}
                            apiService={Api.AfluenciaDiariaPeatonal}
                            args={{ anio1: dateFormated1, anio2: dateFormated2, mes: dateFormatedMes, numero: 2, unidadEconomica: unidadEconomica.value, zona: zona, token: useGetToken() }} // * para filters
                            conditions={true}
                            hideFilter={true}
                            pgSize={15}
                            hidePagination={true}
                            fileNameDownload={"Reporte Afluencia Diaria Peatonal - " + dateFormatedMes + " " + dateFormated1 + " " + dateFormated2 + "2"}
                            transposedSettings={transposedSettings}
                            frecuency={"Diaria"}
                        />
                    </div>
                </div>
            </PermissionsGate>
        </>
    )
}